import AOS from "aos"
import "aos/dist/aos.css"
import { Link } from "gatsby"
import React, { memo, useEffect } from "react"
import { useFooterMetadata } from "../../../queries/useFooterMetaData"
import TopArrow from "../../topArrow/topArrow"
import * as style from "./footer.module.css"
import FooterBottom from "./footerBottom/footerBottom"
import FooterClutch from "./footerClutch/footerClutch"
import FooterTop from "./footerTop/footerTop"

const Footer = ({ footerMenu, homeData }) => {
  const footerData = useFooterMetadata()

  const {
    footerLogo,
    footerContent,
    footerSocialTitle,
    footerMenuList,
    footerSocialIcons,
    footerClutchList,
    footerSvgLogoShow,
    footerImage,
  } = footerData.wpPage.FooterpageFields


  useEffect(() => {
    const loadDrift = () => {
      if (window.drift) return; // Prevent multiple loads
      const script = document.createElement("script")
      script.defer = "true"
      script.innerHTML = `
              !function(){
                var t;
                if (t = window.driftt = window.drift = window.driftt || [], !t.init) return t.invoked ? void (window.console && console.error && console.error("Drift snippet included twice.")) : (t.invoked = !0,
                t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ],
                t.factory = function(e) {
                  return function() {
                    var n;
                    return n = Array.prototype.slice.call(arguments), n.unshift(e), t.push(n), t;
                  };
                }, t.methods.forEach(function(e) {
                  t[e] = t.factory(e);
                }), t.load = function(t) {
                  var e, n, o, i;
                  e = 3e5, i = Math.ceil(new Date() / e) * e, o = document.createElement("script"),
                  o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + i + "/" + t + ".js",
                  n = document.getElementsByTagName("script")[0], n.parentNode.insertBefore(o, n);
                });
              }();
              drift.SNIPPET_VERSION = '0.3.1';
              drift.load('${process.env.GATSBY_DRIFT_ID}');
              `
      document.getElementsByTagName("head")[0].appendChild(script)
    }
    const handleUserInteraction = () => {
      loadDrift();
      window.removeEventListener("mousemove", handleUserInteraction);
      window.removeEventListener("scroll", handleUserInteraction);
      window.removeEventListener("touchstart", handleUserInteraction);
    };

    window.addEventListener("mousemove", handleUserInteraction, { once: true });
    window.addEventListener("scroll", handleUserInteraction, { once: true });
    window.addEventListener("touchstart", handleUserInteraction, { once: true });

    return () => {
      window.removeEventListener("mousemove", handleUserInteraction);
      window.removeEventListener("scroll", handleUserInteraction);
      window.removeEventListener("touchstart", handleUserInteraction);
    };
  }, []);

  // useEffect(() => {
  //   setTimeout(function () {
  //     const script = document.createElement("script")
  //     script.defer = "true"
  //     script.innerHTML = `
  //           !function(){
  //             var t;
  //             if (t = window.driftt = window.drift = window.driftt || [], !t.init) return t.invoked ? void (window.console && console.error && console.error("Drift snippet included twice.")) : (t.invoked = !0,
  //             t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ],
  //             t.factory = function(e) {
  //               return function() {
  //                 var n;
  //                 return n = Array.prototype.slice.call(arguments), n.unshift(e), t.push(n), t;
  //               };
  //             }, t.methods.forEach(function(e) {
  //               t[e] = t.factory(e);
  //             }), t.load = function(t) {
  //               var e, n, o, i;
  //               e = 3e5, i = Math.ceil(new Date() / e) * e, o = document.createElement("script"),
  //               o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + i + "/" + t + ".js",
  //               n = document.getElementsByTagName("script")[0], n.parentNode.insertBefore(o, n);
  //             });
  //           }();
  //           drift.SNIPPET_VERSION = '0.3.1';
  //           drift.load('${process.env.GATSBY_DRIFT_ID}');
  //           `
  //     document.getElementsByTagName("head")[0].appendChild(script)
  //   }, 7000)
  // }, [])

  useEffect(() => {
    setTimeout(() => {
      AOS.init({
        once: true,
      })
    }, 500) // Added a short delay before initializing
  }, [])

  // for copyright years
  const currentYear = new Date().getFullYear()

  return (
    <>
      <footer className="section_bottomPadding dark-bg">
        <div className="container" data-aos="fade-up" data-aos-delay="50">
          <div className={style.footer_wrapper}>
            <FooterTop
              footerLogo={footerLogo}
              footerSocialTitle={footerSocialTitle}
              footerContent={footerContent}
              footerSocialIcons={footerSocialIcons}
              footerMenuList={footerMenuList}
              footerSvgLogoShow={footerSvgLogoShow}
              footerImage={footerImage}
            />
            <FooterClutch footerClutchList={footerClutchList} />
            <FooterBottom footerMenu={footerMenu} homeData={homeData} />
          </div>
        </div>
        {/* bottom Footer */}
        <div className={style.footer_bottom}>
          <div className="container">
            <div className="row">
              <div
                className={`${style.footer_bottom} ${style.inner_footer_bottom}`}
              >
                <ul className={style.footer_nav}>
                  {footerMenu?.nodes.map((item, index) => {
                    return (
                      <li key={index}>
                        <Link to={item?.url ?? "#"}>{item?.label}</Link>
                      </li>
                    )
                  })}
                </ul>
                <span className={style.copy}>
                  © 2006 – {currentYear} AgileInfoways LLC. All Rights Reserved
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <TopArrow />
    </>
  )
}

export default memo(Footer)
